
// Template: resources/views/admin/appearance.blade.php

import HomepageVariants from './HomepageVariants.vue';
import * as utils from '../support/utils';

export default {

    name: "Appearance",

    components: { HomepageVariants },

    props: ['active-theme'],

    data() {
        return {
            theme: this.activeTheme,
            toggledPalettes: false,
            toggledHomepageVariants: false
        }
    },

    computed: {

    },

    methods: {
        selectTheme(theme) {
            if(!this.isActive(theme)){
                this.theme = theme;
                this.toggledPalettes = false;
                utils.smoothScroll(document.body, 0, 0);
            }
        },

        isActive(theme) {
            return this.theme === theme;
        },

        togglePalettes() {
            this.toggledPalettes = !this.toggledPalettes;
        }
    }
};
